<template>
  <div class="klimahelden-expand" :class="{expanded: isExpanded}">
    <button @click="toggle" :class="type">
            <span>
                <span>
                    <slot name="headline"></slot>
                </span>
                <span></span>
                <span class="icon-rotate">
                    <i :class="icon"></i>
                </span>
            </span>
    </button><transition
      name="io-expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
  ><div v-show="isExpanded">
    <slot></slot>
  </div>
  </transition>
  </div>
</template>

<script>
export default {
  name: 'Expand',

  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: () => 'fas fa-chevron-down',
    },
    expanded: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  data() {
    return {
      isExpanded: this.expanded,
    };
  },

  methods: {
    enter(element) {
      const $elem = element;
      const { width } = getComputedStyle($elem);

      $elem.style.width = width;
      $elem.style.position = 'absolute';
      $elem.style.visibility = 'hidden';
      $elem.style.height = 'auto';

      const { height } = getComputedStyle(element);

      $elem.style.width = null;
      $elem.style.position = null;
      $elem.style.visibility = null;
      $elem.style.height = 0;

      const h = getComputedStyle(element).height;

      if (h !== null) {
        requestAnimationFrame(() => {
          $elem.style.height = height;
        });
      }
    },

    afterEnter(element) {
      const $elem = element;

      $elem.style.height = 'auto';
    },

    leave(element) {
      const $elem = element;
      const { height } = getComputedStyle($elem);

      $elem.style.height = height;

      const h = getComputedStyle($elem).height;

      if (h !== null) {
        requestAnimationFrame(() => {
          $elem.style.height = 0;
        });
      }
    },

    toggle() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/scss/base';

.klimahelden-expand {
  > button {
    width: 100%;
    text-align: left;
    outline: 0 !important;
    border: 0 !important;
    background: transparent !important;
    color: #3D3D3D !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    @include roboto-bold(30px);

    padding: 0 0 0em;

    transition: padding .5s ease;

    + div {
      @include font-size(18px);

      @media (min-width: map_get($grid-breakpoints, 'md')) {
        @include font-size(20px);
      }

      @media (min-width: map_get($grid-breakpoints, 'lg')) {
        @include font-size(30px);
      }

      padding-top: .66666em;
    }

    > span {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;

      > span {
        align-self: center;

        &:first-child, &:nth-child(3) {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 auto;
          flex: 0 0 auto;
          width: auto;
          max-width: none;
          @include font-size(18px);

          @media (min-width: map_get($grid-breakpoints, 'md')) {
            @include font-size(20px);
          }

          @media (min-width: map_get($grid-breakpoints, 'lg')) {
            @include font-size(30px);
          }
        }
        &:nth-child(2) {
          -ms-flex-preferred-size: 0;
          flex-basis: 0;
          -webkit-box-flex: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
          max-width: 100%;
        }

        &:nth-child(3) {
          color: #64963B;
        }

        &:nth-child(1) {
          @include roboto-bold(30px);
        }
      }
    }

    .icon-rotate {
      > i, > svg {
        will-change: transform;
        transform: rotate(0deg);
        transition: transform .575s ease-out;
      }
    }
  }

  &.expanded {
    > button {
      position: relative;

      padding: 0 0 1em;

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        bottom: 0;
        background-color: #DBDBDB;
        position: absolute;
      }

      .icon-rotate {
        > i, > svg {
          transform: rotate(-180deg);
        }
      }
    }
  }
}

* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.io-expand-enter-active,
.io-expand-leave-active {
  transition: height .575s ease-in-out;
  overflow: hidden;
}

.io-expand-enter,
.io-expand-leave-to {
  height: 0;
}
</style>
